module.exports = __webpack_public_path__ + "static/media/icon-check.27c42fd3.svg";